import React, { Component } from "react";
import { Slide } from "react-slideshow-image"
import "react-slideshow-image/dist/styles.css"
import './Hero.css'
import slider1 from '../../assets/slides/slide-1.png'
import slider2 from '../../assets/slides/slide-2-1.png'
import slider3 from '../../assets/slides/slide-3.png'
import slider4 from '../../assets/slides/slide-4-1.png'
import slider5 from '../../assets/slides/slide-5.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
library.add(fas)


class Hero extends Component {
  constructor() {
    super();
    this.slideRef = React.createRef();
    this.back = this.back.bind(this);
    this.next = this.next.bind(this);
    this.state = {
      current: 0
    };
  }

  back() {
    this.slideRef.current.goBack();
  }

  next() {
    this.slideRef.current.goNext();
  }

  render() {
    const properties = {
      duration: 3000,
      autoplay: true,
      transitionDuration: 500,
      arrows: false,
      infinite: true,
      easing: "ease",
     
    };
    const slideImages = [
      {
        url:slider1,
        src:'/product-category/vlsi-courses-for-freshers/'
      },
      {
        url:slider2,
        src:'/product/physical-design'
      },
      {
        url:slider3,
        src:'/product/asic-verification/'
      },
      {
        url:slider4,
        src:'/product/analog-layout-design/'
      },
      {
        url:slider5,
        src:'/placements'
      },

     ];
    return (
      <div className="hero-section bg-1">
        
          <div className="slide-container">
            <Slide ref={this.slideRef} {...properties}>
              {slideImages.map((each, index) => (
                <div key={index} className="each-slide">
                  <Link>
                  <img className="lazy" src={each.url} alt="sample" />
                  </Link>
                </div>
              ))}
            </Slide>
          </div>
          <div className="container">
            <div className="slide-container buttons">
              <button onClick={this.back} type="button">
              <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
              </button>
              <button onClick={this.next} type="button">
              <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
              </button>
            </div>
        </div>  
      </div>
    );
  }
}

export default Hero;
